"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactGa = require("react-ga");

var _brightDates = require("bright-dates");

var _LinkButton = _interopRequireDefault(require("../../LinkButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tmargin: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Shortcut = (0, _styledComponents.default)(_LinkButton.default)(_templateObject());
Shortcut.displayName = 'Shortcut';

var shortcuts = function shortcuts(set, dateRange) {
  var result = [{
    name: 'Today',
    range: {
      from: (0, _brightDates.date)(),
      to: (0, _brightDates.date)()
    }
  }];
  if (!dateRange) return result;

  if (set === 'current') {
    result.push({
      name: 'This week',
      range: {
        from: (0, _brightDates.date)().startOf('isoWeek'),
        to: (0, _brightDates.date)().endOf('isoWeek').startOf('day')
      }
    }, {
      name: 'This month',
      range: {
        from: (0, _brightDates.date)().startOf('month'),
        to: (0, _brightDates.date)().endOf('month').startOf('day')
      }
    });
  } else if (set === 'last') {
    result.push({
      name: 'Last week',
      range: {
        from: (0, _brightDates.date)().subtract(6, 'days'),
        to: (0, _brightDates.date)()
      }
    }, {
      name: 'Last 4 weeks',
      range: {
        from: (0, _brightDates.date)().subtract(27, 'days'),
        to: (0, _brightDates.date)()
      }
    });
  } else if (set === 'next') {
    result.push({
      name: 'Next week',
      range: {
        from: (0, _brightDates.date)().add(6, 'days'),
        to: (0, _brightDates.date)()
      }
    }, {
      name: 'Next 4 weeks',
      range: {
        from: (0, _brightDates.date)().add(27, 'days'),
        to: (0, _brightDates.date)()
      }
    });
  }

  return result;
};

var Shortcuts = function Shortcuts(_ref) {
  var set = _ref.set,
      dateRange = _ref.dateRange,
      shortcutClicked = _ref.shortcutClicked,
      _ref$GA = _ref.GA,
      category = _ref$GA.category,
      actionId = _ref$GA.actionId;
  return _react.default.createElement(_react.default.Fragment, null, shortcuts(set, dateRange).map(function (_ref2) {
    var name = _ref2.name,
        range = _ref2.range;
    return _react.default.createElement(Shortcut, {
      key: name,
      onClick: function onClick() {
        (0, _reactGa.event)({
          category: category,
          action: actionId + " - " + name + " shortcut"
        });
        shortcutClicked(range);
      }
    }, name);
  }));
};

Shortcuts.displayName = 'Shortcuts';
Shortcuts.propTypes = {
  set: (0, _propTypes.oneOf)(['today', 'current', 'last', 'next']),
  dateRange: _propTypes.bool,
  shortcutClicked: _propTypes.func.isRequired,
  GA: (0, _propTypes.shape)({
    category: _propTypes.string,
    action: _propTypes.string
  }).isRequired
};
Shortcuts.defaultProps = {
  set: 'today',
  dateRange: false
};
var _default = Shortcuts;
exports.default = _default;